import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { Subscription } from "rxjs";
import { FilterItem, FilterOptions } from "../../models";

@Component({
	selector: "app-chip-filter",
	templateUrl: "./chip-filter.component.html",
	styleUrls: ["./chip-filter.component.scss"],
})
export class ChipFilterComponent implements OnInit, OnDestroy {
	@Input() filterOptions: FilterOptions;
	@Input() filterChips: FilterItem[];
	@Input() savedSearch: string;
	@Output() filtersToggled = new EventEmitter<FilterItem>();
	@Output() searchSubmit = new EventEmitter<string>();
	@Output() filtersCleared = new EventEmitter();
	@Output() newItemAdded = new EventEmitter();
	@Output() searchFilterToggled = new EventEmitter();
	@Output() chipsMinimizeToggled = new EventEmitter();
	@Output() chipsSortToggled = new EventEmitter();
	@Output() searchValueChanged = new EventEmitter<string>();
	searchQuery = new UntypedFormControl("");
	searchSub: Subscription;
	showAdvancedFilter = false;
	deviceFilter = "";
	selectedChip = "";

	ngOnInit() {
		// this.searchQuery.value = this.savedSearch
		this.searchQuery.setValue(this.savedSearch);
		this.searchSub = this.searchQuery.valueChanges.subscribe((value) => {
			this.searchValueChanged.emit(value);
		});
	}

	clearSearch() {
		this.searchQuery.setValue("");
		this.submitSearch();
	}

	ngOnDestroy() {
		if (this.searchSub != null) {
			this.searchSub.unsubscribe();
		}
	}

	submitSearch() {
		this.searchSubmit.emit(this.searchQuery.value);
	}

	toggleChip(chip: FilterItem) {
		//this.clear();

		this.filterChips.forEach((element) => {
			element.isSelected = false;
		});

		// if(this.deviceFilter == chip.title){
		//   chip.isSelected = !chip.isSelected;
		//   this.showAdvancedFilter = !this.showAdvancedFilter;
		// }else{
		//   this.deviceFilter = chip.title;
		//   chip.isSelected = true;
		//   this.showAdvancedFilter = true;
		// }

		// if(chip.isSelected == null){
		//   chip.isSelected = true
		//   this.showAdvancedFilter = true;
		// }else{
		//   this.showAdvancedFilter = !this.showAdvancedFilter;
		// }

		this.deviceFilter = chip.title;
		if (this.selectedChip == chip.title && this.showAdvancedFilter) {
			this.showAdvancedFilter = false;
			chip.isSelected = true;
		} else {
			this.showAdvancedFilter = true;
		}
		this.selectedChip = chip.title;
		// this.showAdvancedFilter = !this.showAdvancedFilter;

		chip.isSelected == null ? (chip.isSelected = true) : (chip.isSelected = !chip.isSelected);
		this.filtersToggled.emit(chip);
	}

	addItem() {
		this.newItemAdded.emit();
	}

	clear(): void {
		this.showAdvancedFilter = false;
		this.filterChips.forEach((element) => {
			element.isSelected = false;
		});

		this.filtersCleared.emit();
	}

	searchFilterToggle(): void {
		this.searchFilterToggled.emit();
	}

	chipsMinimizeToggle(): void {
		this.chipsMinimizeToggled.emit();
	}

	chipsSortToggle(): void {
		this.chipsSortToggled.emit();
	}
}
